import { startCase } from 'lodash'

export function titleCase(val) {
  return startCase(val?.toLowerCase?.())
}
